export enum ConditionOperator {
  EQUALS = "EQUALS",
  NOT_EQUALS = "NOT_EQUALS",
  // GREATER_THAN = "GREATER_THAN",
  // LESS_THAN = "LESS_THAN",
  // GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  // LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  CONTAINS = "CONTAINS",
  // NOT_CONTAINS = "NOT_CONTAINS",
  // IS_EMPTY = "IS_EMPTY",
  // IS_NOT_EMPTY = "IS_NOT_EMPTY",
  // IS_ANSWERED = "IS_ANSWERED",
  // IS_NOT_ANSWERED = "IS_NOT_ANSWERED"
  YEARS_AGO_MINIMUM = "YEARS_AGO_MINIMUM",
  YEARS_AGO_MAXIMUM = "YEARS_AGO_MAXIMUM",
  SUM = "SUM",
}
